import React, { useEffect } from "react";
import { Grid, IconButton, Box, useTheme } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

const fieldBoxSx = (theme) => ({
  padding: theme.spacing(1.5),
  borderRadius: "12px",
  backgroundColor: "#f9f9f9",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
  position: "relative",
  width: "100%",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: { padding: theme.spacing(1.5) },
});
const closeBtnSx = {
  position: "absolute",
  right: 10,
  top: "50%",
  padding: "8px",
  transform: "translateY(-50%)",
  color: "#666",
  "&:hover": { color: "#d32f2f" },
};
const inputFieldSx = { width: "75%" };

const FreqPowerCard = ({ bodies, setBodies, disabled = false, onRemove }) => {
  const theme = useTheme();

  const handleBodyChange = (index, field, value) => {
    setBodies(arr => arr.map((body, i) =>
      i === index
        ? {
            ...body,
            [field]:
              field === "rrpm_c"
                ? value === "" ? "" : parseInt(value, 10)
                : field === "power"
                  ? value === "" ? "" : parseFloat(value)
                  : value
          }
        : { ...body }
    ));
  };

  return (
    <>
      {bodies.map((body, index) => (
        <div className="py-15" key={index}>
          <Box sx={fieldBoxSx(theme)}>
            {!disabled && (
              <IconButton
                size="small"
                sx={closeBtnSx}
                onClick={() => onRemove(index)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}

            <Grid container alignItems="center" spacing={5}>
              <Grid item xs={4}>
                <label className="title">Frequency:</label>
                <input
                  className={`add-input xl`}
                  placeholder="Enter Frequency"
                  type="text"
                  value={body.frequency}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "frequency", e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={3}>
                <label className="title">rrpm_c:</label>
                <input
                  className="add-input xl" style={inputFieldSx}
                  placeholder="Enter rrpm_c"
                  type="number"
                  value={body.rrpm_c}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "rrpm_c", e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={3}>
                <label className="title">Power:</label>
                <input
                  className="add-input xl" style={inputFieldSx}
                  placeholder="Enter Power"
                  type="number"
                  value={body.power}
                  disabled={disabled}
                  onChange={(e) =>
                    handleBodyChange(index, "power", e.target.value)
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </div>
      ))}
    </>
  );
};

export default FreqPowerCard;